import React, { useState, useMemo, useEffect } from 'react';
import {
    Drawer,
    DrawerBody,
    DrawerFooter,
    DrawerHeader,
    DrawerOverlay,
    DrawerContent,
    DrawerCloseButton,
    Button,
    Input
} from "@chakra-ui/react";
import Select from "react-select";
import { Checkbox } from "@chakra-ui/react";
import ProgressBar from '../../utils/progressBar/ProgressBar';
import {getEmployees} from '../../redux/reduxApi/employeeReduxApi';
import { useDispatch, useSelector } from 'react-redux';
import { toast } from 'react-toastify';
import {  dateComponent, numberComponent, } from '../../utils/commonFunction/SearchPicklist';
import { setFilteredStatus } from '../../redux/reduxSlice/EmployeeSlice';
const statusOptions = [
    { value: 'Active', label: 'Active' },
    { value: 'Inactive', label: 'Inactive' },
    { value: 'Underprocess', label: 'Underprocess' },
    { value: 'Waiting on Document', label: 'Waiting on Document' },
];
const priorityOptions = [
    { value: 'High', label: 'High' },
    { value: 'Low', label: 'Low' },
    { value: 'Medium', label: 'Medium' },

];

const stringComponent = [
  { label: "Is", value: "is" },
  { label: "Is Not", value: "is-not" },
]


export default function RoleSearchDrawer(props) {
    const { isClose } = props;
    const dispatch= useDispatch();
    const [showProgressBar, setShowProgressBar] = useState(false);
    const [ShowName, setShowName] = useState(false);
    const [isDateTimeBetween, setisDateTimeBetween] = useState(false);
    const roleList = useSelector((state) => state.utils.roleList)

    const [role, setRole] = useState([])
    const roleData = useMemo(() => {
      return roleList.map((item) => ({
        label: item.roles.roleName,
        value: item.roles.ROWID
      }))
    }, [JSON.stringify(roleList)])
  
    useEffect(() => {
      setRole(roleData);
    }, [roleData])
  
    const [checkedFields, setCheckedFields] = useState({
        employeeName: false,
        status: false,
        emailAddress: false,
        createdDateTime: false,
        employeeStatus: false,
        CREATEDTIME: false,
        permissions: false,

    });
    const [formData, setFormData] = useState({
        employeeName: "",
        status: "",
        emailAddress: "",
        employeeStatus: "",
        permissions: "",
        CREATEDTIME: "",
        createdDateTime2: "",

    })
    const closeDrawer = () => {
        isClose();
        setCheckedFields({});
        setFormData({});
    }

    // handle change
    const handleChange = (e, fieldName = null) => {
        if (e?.target) {
            const { name, value } = e.target;
            setFormData(prevState => ({ ...prevState, [name]: value }));
        } else if (fieldName) {
            setFormData(prevState => ({
                ...prevState,
                [`${fieldName}Operation`]: e.value
            }));
            setShowName(["is", "is-not", "before", "after"].includes(e.value));
            setisDateTimeBetween(["between"].includes(e.value));
        } else {
            setFormData(prevState => ({ ...prevState, leadType: e.value }));
        }
    };

    // const handleFieldCheckbox = (field) => (e) => {
    //     setCheckedFields((prev) => ({
    //         ...prev,
    //         [field]: e.target.checked,
    //     }));
    //     // Reset the dropdown and input if unchecked
    //     if (!e.target.checked) {
    //         // setProductSelectedOption({ label: "Is", value: "is" });
    //         setShowName(false);
    //     }
    // };
    //handle Search
    
    
      const handleFieldCheckbox = (field) => (e) => {
    const isChecked = e.target.checked;

    setCheckedFields((prev) => ({
      ...prev,
      [field]: isChecked,
    }));

    // Special handling for firstName field
    if (field === "companyName" && isChecked) {
      setFormData(prev => ({
        ...prev,
        companyNameOperation: "like" // Automatically set to "like" operation
      }));
      setShowName(true); // Show the input field immediately
    }
    if (field === "employeeName" && isChecked) {
      setFormData(prev => ({
        ...prev,
        employeeNameOperation: "like" // Automatically set to "like" operation
      }));
      setShowName(true); // Show the input field immediately
    }
    if (field === "revenue" && isChecked) {
      setFormData(prev => ({
        ...prev,
        revenueOperation: "like" // Automatically set to "like" operation
      }));
      setShowName(true); // Show the input field immediately
    }
    if (field === "email" && isChecked) {
      setFormData(prev => ({
        ...prev,
        emailOperation: "like" // Automatically set to "like" operation
      }));
      setShowName(true); // Show the input field immediately
    }

    if (field === "contactNumber" && isChecked) {
      setFormData(prev => ({
        ...prev,
        contactNumberOperation: "like" // Automatically set to "like" operation
      }));
      setShowName(true); // Show the input field immediately
    }

    // Reset the dropdown and input if unchecked
    if (!isChecked) {
      setFormData(prev => ({
        ...prev,
        [`${field}Operation`]: "",
        [field]: ""
      }));
      setShowName(false);
    }
  };

    
    // const handleSearch = async () => {
    //     const search = [];
    //     const fields = [
    //         "employeeName", "employeeStatus", "email", "permissions", "CREATEDTIME",
    //     ];

    //     fields.forEach((field) => {
    //         if (formData[field] !== undefined && formData[field] !== "") {
    //             search.push({
    //                 field: field,
    //                 operation: formData?.[`${field}Operation`] || "equals",
    //                 value: formData[field]
    //             });
    //         }
    //     });
    //     setShowProgressBar(true)
    //     try {
    //         // // const response = await dispatch(getLeads({ search }));
    //         // const response = await dispatch(getEmployees({ page: 1, size: 100, search }));
    //         // // const response = await dispatch(getLeads({ page: currentPage, size: itemsPerPage, search: {search} }));

    //         // console.log("Full API Response:", response);
    //         const searchQuery = { page: 1, search, }
    //         sessionStorage.setItem("employeeSearchQuery", JSON.stringify(searchQuery))
    //         const response = await dispatch(getEmployees({search }));
    //         console.log("response--->",response?.payload?.data);
            
    //         if (search.length > 0 && response?.payload?.data?.data?.success) {
    //           dispatch(setFilteredStatus(true));
    //           console.log("setFilteredStatus",setFilteredStatus);
              
    //         }

    //         setShowProgressBar(false)

    //         const data = response?.payload || response;
    //         console.log("Extracted Data:", data);

    //         if (response?.error?.code === "ERR_BAD_REQUEST" || response?.error?.message?.includes("404")) {
    //             toast.warning("No records found!");
    //         } else {
    //             toast.success("Employees Filtered Successfully");
    //             closeDrawer();
    //             setShowName(false);
    //             setFormData({});
    //             setCheckedFields(false)

    //         }
    //     } catch (error) {
    //         setShowProgressBar(false)
    //         toast.error("Error in filtering Employees");
    //         console.error("Fetch Error:", error);
    //     }
    // };


    const handleSearch = async () => {
    const search = [];
    const fields = [
        "employeeName", "employeeStatus", "email", "permissions", "CREATEDTIME",
    ];

    fields.forEach((field) => {
        if (formData[field] !== undefined && formData[field] !== "") {
            search.push({
                field: field,
                operation: formData?.[`${field}Operation`] || "equals",
                value: formData[field]
            });
        }
    });
    setShowProgressBar(true)
    try {
        const searchQuery = { page: 1, search }
        sessionStorage.setItem("employeeSearchQuery", JSON.stringify(searchQuery))
        const response = await dispatch(getEmployees({ search }));
        
        // Update this part since response structure changed
        // console.log("response--->", response?.payload?.data);
        // console.log("setFilteredStatus",setFilteredStatus);
        
        if (search.length > 0 && response?.payload?.success) {
            dispatch(setFilteredStatus(true));
        }

        setShowProgressBar(false)

        if (response?.error?.code === "ERR_BAD_REQUEST" || response?.error?.message?.includes("404")) {
            toast.warning("No records found!");
        } else {
            toast.success("Employees Filtered Successfully");
            closeDrawer();
            setShowName(false);
            setFormData({});
            setCheckedFields(false)
        }
    } catch (error) {
        setShowProgressBar(false)
        toast.error("Error in filtering Employees");
        console.error("Fetch Error:", error);
    }
};



      
    const handleReset = () => {
    setFormData({
     employeeName: "",
     status: "",
     emailAddress: "",
     employeeStatus: "",
     permissions: "",
     CREATEDTIME: "",
     createdDateTime2: "",
    });

    setCheckedFields({
   employeeName: false,
   status: false,
   emailAddress: false,
   createdDateTime: false,
   employeeStatus: false,
   CREATEDTIME: false,
   permissions: false,
    });

    setShowName(false);
  };

    return (
        <div>
            <Drawer
                isOpen={props.isOpen}
                placement="right"
                size="xs"
                onClose={closeDrawer} >
                <DrawerOverlay />
                <DrawerContent>
                    <DrawerCloseButton />
                    <DrawerHeader>Filter Users
                        <Button
                          variant=""
                          colorScheme="green"
                          fontWeight="medium"
                          fontSize="md"
                          px={4}
                          py={1}
                          size="sm"
                          ml={3}
                          borderRadius="full"
                          border="1px solid #ddd"
                          transition="all 0.3s ease"
                          _hover={{
                            boxShadow: "0 0 10px 3px rgba(20, 255, 126, 0.4)", // glow
                          }}
                          onClick={handleReset}
                        >
                          Reset
                        </Button>
                    </DrawerHeader>
                    <DrawerBody>

                        {showProgressBar && <ProgressBar colorScheme='pink' />}
                        <div className="card mb-4 p-0" style={{ backgroundColor: "#FFFFFF" }}>
                            <div className="card-body p-0">
                                <form>
                                    <div className="employeeName mt-2" style={{ width: '100%' }}>
                                        <div className="d-flex gap-3">
                                            <Checkbox onChange={handleFieldCheckbox("employeeName")}>Employee Name</Checkbox>
                                        </div>
                                       
                                            {checkedFields.employeeName && (
                                              <Input
                                                type="text"
                                                className="form-control mt-2"
                                                placeholder="Search Employee Name..."
                                                name="employeeName"
                                                value={formData.employeeName || ""}
                                                onChange={handleChange}
                                              />
                                            )}
                                    </div>
                                    <div className="emailAddress  mt-2" style={{ width: '100%' }}>
                                        <div className="d-flex gap-3">
                                            <Checkbox onChange={handleFieldCheckbox("email")}>Email</Checkbox>
                                        </div>
                                        {checkedFields.email && (
                                           <Input
                                             type="text"
                                             className="form-control mt-2"
                                             placeholder="Search Email..."
                                             name="email"
                                             value={formData.email || ""}
                                             onChange={handleChange}
                                           />
                                         )}
                                    </div>
                                    <div className="employeeStatus mt-2" style={{ width: '100%' }}>
                                        <div className="d-flex gap-3">
                                            <Checkbox onChange={handleFieldCheckbox("employeeStatus")}>Employee Status</Checkbox>
                                        </div>
                                        {checkedFields.employeeStatus && (
                                            <div className="mt-2" style={{ width: '100%' }}>
                                                <Select 
                                                options={stringComponent} 
                                                name="employeeStatusOperation" 
                                                style={{ width: '100%' }}
                                                onChange={(e) => handleChange(e, 'employeeStatus')}
                                                value={stringComponent.find(option => option.value === formData.employeeStatusOperation)} />
                                                <div className='mt-1'>
                                                    <Select options={statusOptions} name= "employeeStatus" value={statusOptions.find(option => option.value === formData.employeeStatus)} 
                                                       onChange={(option) => setFormData(prevFormData => ({ ...prevFormData, employeeStatus: option.value }))} />
                                                </div>
                                            </div>)}
                                    </div>
                                    <div className="Permission mt-2" style={{ width: '100%' }}>
                                        <div className="d-flex gap-3">
                                            <Checkbox onChange={handleFieldCheckbox("permissions")}>Permission</Checkbox>
                                        </div>
                                        {checkedFields.permissions && (
                                            <div className="mt-2" style={{ width: '100%' }}>
                                                <Select options={stringComponent} name="permissionsOperation" style={{ width: '100%' }}
                                                    onChange={(e) => handleChange(e, 'permissions')}
                                                    value={stringComponent.find(option => option.value === formData.permissionsOperation)} />
                                                <div className='mt-1'>
                                                    <Select name= "permissions" value={role.find(option => option.value === formData.permissions)} 
                                                        options={role} defaultValue={role && role?.find((item) => (item.value === formData?.permissions))}
                                                        onChange={(option) => { setFormData(prevFormData => ({ ...prevFormData, permissions: option.value })) }}/>
                                                </div>
                                            </div>)}
                                    </div>

                                    {/* <div className="createdDateTime mt-2" style={{ width: '100%' }}>
                                        <div className="d-flex gap-3">
                                            <Checkbox onChange={handleFieldCheckbox("CREATEDTIME")}>Created Date Time</Checkbox>
                                        </div>
                                        {checkedFields.CREATEDTIME && (
                                            <div className="mt-2" style={{ width: '100%' }}>
                                                <Select options={dateComponent} name="createdDateTimeOperation" style={{ width: '100%' }}
                                                    onChange={(e) => handleChange(e, 'CREATEDTIME')}
                                                    value={dateComponent.find(option => option.value === formData.createdDateTimeOperation)} />
                                                <div className='mt-1'>
                                                    <input type="datetime-local" className="form-control mt-2" placeholder="Due Date" name="CREATEDTIME"
                                                        value={formData.CREATEDTIME || ""} onChange={handleChange} />
                                                </div>
                                                {
                                                    isDateTimeBetween && <div className='mt-1'>
                                                        <input type="datetime-local" className="form-control mt-2" placeholder="Due Date" name="createdDateTime2"
                                                            value={formData.createdDateTime2 || ""} onChange={handleChange} />
                                                    </div>
                                                }
                                            </div>)}
                                    </div> */}
                                </form>
                            </div>
                        </div>

                    </DrawerBody>
                    <center>
                        <DrawerFooter style={{ display: "inline-block" }}>
                            <div className="gap-3 d-flex">
                                <button variant="outline" mr={3} onClick={closeDrawer} className="cancel-button" >
                                    Cancel
                                </button>
                                <button className="create-button" onClick={handleSearch}>
                                    Search
                                </button>
                            </div>
                        </DrawerFooter>
                    </center>
                </DrawerContent>

            </Drawer>
        </div>
    )
}
